var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPluswhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.951,
    height: 17.949,
    viewBox: "0 0 17.951 17.949",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Plus",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_2",
    "data-name": "Subtraction 2",
    d: "M22451.477,16745.947a8.475,8.475,0,1,1,8.473-8.473A8.486,8.486,0,0,1,22451.477,16745.947Zm-3.377-9.115a.7.7,0,1,0,0,1.4h2.908v2.84a.7.7,0,0,0,1.4,0v-2.84h2.908a.7.7,0,0,0,0-1.4h-2.908v-2.977a.7.7,0,1,0-1.4,0v2.977Z",
    transform: "translate(-22442.998 -16728.998)",
    fill: "#fff",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPluswhite);
export default __webpack_public_path__ + "static/media/Pluswhite.02282b10c216177ffcc56d12462ed09f.svg";
export { ForwardRef as ReactComponent };